import React from 'react';
import PropTypes from 'prop-types';

import LabeledSelect from './LabeledSelect';

export const RANGE_LABELS = {
  '24h': 'Last 24 hours',
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  all: 'All time'
};

const LEDGER_RANGES = ['24h', '7d', '30d', '90d'];

// The one range control the ledger views share. Sends stops at 90 days: a whole-ledger aggregate
// over all time is a report, not a health read. Recipients narrows to one person, so it adds "all".
const RangeSelect = ({ value, onChange, options = LEDGER_RANGES }) => (
  <LabeledSelect label='Showing' value={value} onChange={onChange} options={options.map(key => ({ value: key, label: RANGE_LABELS[key] }))} />
);

RangeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string)
};

export default RangeSelect;
